(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["lim-event-times"] && !Shopify.designMode) return;
  try {
    (() => {
    const formatDates = () => {
      document.querySelectorAll('main #block-event_date time[datetime]').forEach(time => {
        const date = new Date(time.dateTime + (time.dateTime.length === 10 ? 'T12:00:00Z' : ''));
        if (Number.isFinite(date.getTime())) time.textContent = new Intl.DateTimeFormat('en-US', {
          timeZone: 'UTC', month: 'long', day: 'numeric', year: 'numeric'
        }).format(date);
      });
      document.querySelectorAll('main #block-event_time .metafield-single_line_text_field').forEach(range => {
        range.textContent = range.textContent.replace(/:00/g, '').replace(/\s*AM/gi, ' a.m.').replace(/\s*PM/gi, ' p.m.').replace(/\s*[-–—]\s*/g, ' to ');
      });
      document.querySelectorAll('main time.metafield-date_time[datetime]').forEach(time => {
        const date = new Date(time.dateTime);
        if (Number.isFinite(date.getTime())) {
          if (time.closest('#block-event_date')) {
            time.textContent = new Intl.DateTimeFormat('en-US', {
              timeZone: 'America/Los_Angeles', month: 'long', day: 'numeric', year: 'numeric'
            }).format(date);
            return;
          }
          if (time.closest('#block-event_time')) {
            time.textContent = new Intl.DateTimeFormat('en-US', {
              timeZone: 'America/Los_Angeles', hour: 'numeric', minute: '2-digit', hour12: true
            }).format(date).replace(':00', '').replace(/\s*AM$/, ' a.m.').replace(/\s*PM$/, ' p.m.');
            return;
          }
          time.textContent = new Intl.DateTimeFormat(document.documentElement.lang || 'en', {
            timeZone: 'America/Los_Angeles', month: 'long', day: 'numeric', year: 'numeric',
            hour: 'numeric', minute: '2-digit', timeZoneName: 'short'
          }).format(date);
        }
      });
    };
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', formatDates, { once: true });
    else formatDates();
    document.addEventListener('shopify:section:load', formatDates);
  })();
  } catch(e) { console.error(e); }
})();

})();
